import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthenticationService } from '../services/authentication.service';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const authenticationService = inject(AuthenticationService);
  const portalCode = authenticationService.activePortalCode.asReadonly();

  if (portalCode) {
    return next(
      req.clone({
        setHeaders: {
          'X-Portal-Code': portalCode() ?? ''
        }
      })
    );
  }
  return next(req);
};
